<ion-header class="remove-safe-area ion-no-border">
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
            <ion-buttons slot="end">
              <ion-button (click)="closeModal()"
                ><ion-icon color="dark" name="close"></ion-icon
              ></ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-header>

<ion-content>
  <app-loading-spinner  *ngIf="!loaded"></app-loading-spinner>
  <form [formGroup]="formGroup">
    <ion-grid *ngIf="loaded && form!=undefined">
      <!-- should ionic set a title? -->
      <ion-row>
        <ion-col style="text-align: center">
          <h2 class="subheader-regular"
          >
            {{ title}}
          </h2>
        </ion-col>
      </ion-row>
      <ion-row *ngFor="let formItem of form">
        <ion-col  class="ion-no-padding single-col-wider">
          <!-- header -->
          <div  *ngIf="formItem.type=='header'">
            <h1 *ngIf="formItem.subtype=='h1'" [innerHTML]="formItem.label"></h1>
            <h2 *ngIf="formItem.subtype=='h2'" [innerHTML]="formItem.label"></h2>
            <h3 *ngIf="formItem.subtype=='h3'" [innerHTML]="formItem.label"></h3>
            <h4 *ngIf="formItem.subtype=='h4'" [innerHTML]="formItem.label"></h4>
            <h5 *ngIf="formItem.subtype=='h5'" [innerHTML]="formItem.label"></h5>
            <h6 *ngIf="formItem.subtype=='h6'" [innerHTML]="formItem.label"></h6>
          </div>

          <!-- paragraph -->
          <div *ngIf="formItem.type=='paragraph'">
            <p class="ion-text-wrap">
              {{ formItem.label }} <a [href]="formItem.addLink" target="_blank" rel="noopener noreferrer" *ngIf="formItem.addLink">
              {{ formItem.addLink }}
              </a>
            </p>
          </div>

          <!-- number -->
          <ion-card style="margin: 0.3em;" *ngIf="formItem.type=='number'" class="card-shadow-3">
            <ion-row>
              <ion-col >
                <ion-item>
                  <ion-label>
                    {{ formItem.label }}
                    <span *ngIf="formItem.required" style="color: red">*</span>
                  </ion-label>

                  <ion-input
                    [placeholder]="formItem.placeholder"
                    [value]="formItem.value"
                    [required]="formItem.required"
                    [formControlName]="formItem.name"
                    type="number"
                    [step]="formItem.step">
                    <span slot="start" *ngIf="formItem.prefix" style="padding: 4px; margin-left: 8px; margin-right: 0px;" class="alert-info">{{ formItem.prefix }}</span>
                  </ion-input>

                  <!-- Increment icon -->
                  <ion-icon
                    *ngIf="formItem.step"
                    name="chevron-up-circle-outline"
                    slot="end"
                    style="cursor: pointer; vertical-align: middle; font-size: x-large;"
                    (click)="incrementNumber(formItem)">
                  </ion-icon>

                  <!-- Decrement icon -->
                  <ion-icon
                    *ngIf="formItem.step"
                    name="chevron-down-circle-outline"
                    slot="end"
                    style="cursor: pointer; vertical-align: middle; font-size: x-large;"
                    (click)="decrementNumber(formItem)">
                  </ion-icon>
                </ion-item>
              </ion-col>

            </ion-row>

          </ion-card>

          <!-- date -->
          <ion-card style="margin: 0.3em;" *ngIf="formItem.type=='date'"  class="card-shadow-3">
            <ion-item lines="none" [id]="formItem.name">
              <ion-label
                >{{formItem.label}}<span
                  *ngIf="formItem.required"
                  style="color: red"
                >
                  *</span
                ></ion-label
              >
              <ion-label [placeholder]="formItem.placeholder" slot="end">
                {{formGroup.value[formItem.name] |
                date:dataSRV.settings['system']['datemask'] }}
              </ion-label>
              <ion-icon *ngIf="formItem.description" color="secondary" style="cursor: pointer;" (click)="presentDescriptionPopover($event,formItem.description)"  name="help-circle" slot="end"></ion-icon>
              <ion-popover [trigger]="formItem.name" size="cover">
                <ng-template>
                  <ion-datetime
                    size="cover"
                    max="2123-05-25T10:19:04.840-07:00"
                    [showDefaultButtons]="true"
                    presentation="date"
                    [required]="formItem.required"
                    [formControlName]="formItem.name"
                  ></ion-datetime>
                </ng-template>
              </ion-popover>
            </ion-item>
          </ion-card>
          <!-- text field -->
          <ion-card *ngIf="formItem.type=='text'" style="margin: 0.3em;"  class="card-shadow-3">
            <ion-item >
              <ion-label position="floating"
                >{{formItem.label}}<span
                  *ngIf="formItem.required"
                  style="color: red"
                >
                  *</span
                ></ion-label
              >
              <ion-input
                [maxlength]="formItem.maxlength"
                [placeholder]="formItem.placeholder"
                [required]="formItem.required"
                [formControlName]="formItem.name"
                *ngIf="formItem.subtype=='text'"
                type="text"
              ></ion-input>
              <ion-input
                [maxlength]="formItem.maxlength"
                [placeholder]="formItem.placeholder"
                [required]="formItem.required"
                [formControlName]="formItem.name"
                *ngIf="formItem.subtype=='tel'"
                type="tel"
              ></ion-input>
              <ion-input
                [maxlength]="formItem.maxlength"
                [placeholder]="formItem.placeholder"
                [required]="formItem.required"
                [formControlName]="formItem.name"
                *ngIf="formItem.subtype=='password'"
                type="password"
              ></ion-input>
              <ion-input
                [maxlength]="formItem.maxlength"
                [placeholder]="formItem.placeholder"
                [required]="formItem.required"
                [formControlName]="formItem.name"
                *ngIf="formItem.subtype=='email'"
                type="email"
                pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{1,4}$"
              ></ion-input>
              <ion-icon *ngIf="formItem.description" color="secondary" style="cursor: pointer;" (click)="presentDescriptionPopover($event,formItem.description)"  name="help-circle" slot="end"></ion-icon>
            </ion-item>
          </ion-card>
          <!-- text area -->
          <ion-card style="margin: 0.3em;" *ngIf="formItem.type=='textarea'"  class="card-shadow-3">
            <ion-item>
              <ion-label position="floating"
                >{{formItem.label}}<span
                  *ngIf="formItem.required"
                  style="color: red"
                >
                  *</span
                ></ion-label
              >
              <ion-textarea 
                [rows]="formItem.rows"
                [maxlength]="formItem.maxlength"
                [placeholder]="formItem.placeholder"
                [required]="formItem.required"
                [formControlName]="formItem.name"
              ></ion-textarea>
              <ion-icon *ngIf="formItem.description" color="secondary" style="cursor: pointer;" (click)="presentDescriptionPopover($event,formItem.description)"  name="help-circle" slot="end"></ion-icon>
            </ion-item>
          </ion-card>

          

          <!-- select -->
          <ion-card style="margin: 0.3em;" *ngIf="formItem.type=='select'"  class="card-shadow-3"> 
            <ion-item lines="none">
              <ion-label class="ion-text-wrap"
                >{{formItem.label}}<span
                  *ngIf="formItem.required"
                  style="color: red"
                >
                  *</span
                ></ion-label
              >
              <ion-select
                [multiple]="formItem.multiple"
                [placeholder]="formItem.placeholder"
                [required]="formItem.required"
                [formControlName]="formItem.name"
              >
                <ion-select-option
                  *ngFor="let option of formItem.values"
                  [value]="option.label"
                  >{{option.label}}</ion-select-option
                >
              </ion-select>
              <ion-icon *ngIf="formItem.description" color="secondary" style="cursor: pointer;" (click)="presentDescriptionPopover($event,formItem.description)"  name="help-circle" slot="end"></ion-icon>
            </ion-item>
          </ion-card>

          <!-- checkbox -->
          <ion-card style="margin: 0.3em;"  class="card-shadow-3">
            <ion-item lines="none" *ngIf="formItem.type=='checkbox-group'">
              <div>
                <ion-label class="ion-text-wrap"
                  >{{formItem.label}}<span
                    *ngIf="formItem.required"
                    style="color: red"
                  >
                    *</span
                  ></ion-label
                >
                <div [formGroup]="formGroup.controls[formItem['name']]">
                  <div *ngFor="let option of formItem['values'];last as isLast">
                    <ion-item lines="none">
                      <ion-checkbox
                        slot="start"
                        [formControlName]="option.label"
                      ></ion-checkbox>
                      <ion-label>{{option.label}}</ion-label>
                      
                    </ion-item>
                    <ion-item lines="none" *ngIf="formItem.other && isLast">
                      <!-- <ion-checkbox  slot="start" (ionChange)="otherCheckbox(formItem['name'])" ></ion-checkbox> -->
                      <ion-item lines="none" fill="outline">
                        <ion-label position="floating">other</ion-label>
                        <ion-input formControlName="other"></ion-input>
                      </ion-item>
                    </ion-item>
                  </div>
                  <ion-note slot="helper"
                        >{{formItem.description}}</ion-note
                      >
                </div>
              </div>
            </ion-item>
          </ion-card>

          <!-- radio group -->
          <ion-card style="margin: 0.3em;"  class="card-shadow-3"> 
            <ion-item lines="none" *ngIf="formItem.type=='radio-group'">
              <div>
                <ion-label class="ion-text-wrap"
                  >{{formItem.label}}<span
                    *ngIf="formItem.required"
                    style="color: red"
                  >
                    *</span
                  ></ion-label>

                <ion-radio-group
                  (ionChange)="radioGroupSelected(formItem['name'],$event)"
                  [formControlName]="formItem['name']"
                >
                  <div *ngFor="let radioItem of formItem.values;last as isLast">
                    <ion-item lines="none">
                      <ion-label class="ion-text-wrap">
                        {{radioItem.label}}
                      </ion-label>
                      <ion-radio
                        slot="start"
                        [value]="radioItem.label"
                      ></ion-radio>
                    </ion-item>
                    <ion-item lines="none" *ngIf="formItem.other && isLast">
                      <ion-item lines="none" fill="outline">
                        <ion-label position="floating">other</ion-label>
                        <ion-input
                          (ionChange)="radioGroupOther(formItem['name'],$event)"
                        ></ion-input>
                      </ion-item>
                    </ion-item>
                  </div>
                </ion-radio-group>
              </div>
              <ion-icon *ngIf="formItem.description" color="secondary" style="cursor: pointer;" (click)="presentDescriptionPopover($event,formItem.description)"  name="help-circle" slot="end"></ion-icon>
            </ion-item>
          </ion-card>
          <!-- file upload -->
          <!-- <div *ngIf="formItem.type=='file'">
            <ion-item >
              <ion-label>{{formItem.label}}<span
                *ngIf="formItem.required"
                style="color: red"
                > *</span
              ></ion-label>
              <input hidden type="file" #filepicker (change)="fileSelected($event)"/>
             
                <ion-button (click)="selectFile()" expand="block" color="dark" expand="full" color="dark" >Choose Files</ion-button>
                
                
            </ion-item>
            <ion-item *ngFor="let file of files; let i = index">
              <ion-thumbnail slot="start">
                <ion-img *ngIf="file.type!='.pdf'" [src]="file.data"></ion-img>
                <ion-img *ngIf="file.type=='.pdf'" src="assets/files/pdf.png"></ion-img>
              </ion-thumbnail>
              <ion-label class="ion-text-wrap"> {{ file.name }} </ion-label>
              <ion-button (click)="removeFile(i)" slot="end"  fill="clear">
                <ion-icon color="danger" slot="icon-only" name="trash"></ion-icon>
              </ion-button>
            </ion-item>
          </div> -->

          <!-- autocomplete -->
          <ion-card style="margin: 0.3em;" *ngIf="formItem.type=='autocomplete'"  class="card-shadow-3">
            <div>
              <ion-item>
                <ion-label
                position="floating"
                  >{{formItem.label}}<span
                    *ngIf="formItem.required"
                    style="color: red"
                  >
                    *</span
                  ></ion-label
                >
                <ion-input
                  [placeholder]="formItem.placeholder"
                  [formControlName]="formItem.name"
                  (ionInput)="autoCompleteInput(formItem['values'],formItem.name)"
                >
                </ion-input>
                <ion-icon *ngIf="formItem.description" color="secondary" style="cursor: pointer;" (click)="presentDescriptionPopover($event,formItem.description)"  name="help-circle" slot="end"></ion-icon>
              </ion-item>

              <ion-list *ngIf="formGroup.value[formItem.name].length>0">
                <div
                  *ngFor="let item of formItem['values'] | myFilter:formGroup.value[formItem.name]"
                >
                  <ion-button
                    expand="block"
                    color="secondary"
                    *ngIf="formGroup.value[formItem.name]!=item.value"
                    (click)="autoCompleteSelected(formItem.name,item.label)"
                    button
                  >
                    {{item.label}}</ion-button
                  >
                </div>
              </ion-list>
            </div>
          </ion-card>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="single-col-wider">
          <ion-button
            (click)="submitForm()"
            [disabled]="!formGroup.valid "
            expand="block"
            color="primary"
            >{{ ('keys.data.common.submit' | translate : {Default:'Form
            Description'}) || 'Form Description' }}</ion-button
          >
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>
